import { MessageText, useMessageContext } from 'stream-chat-react'
import {
  BotMessage,
  BotMessageStack,
  MyMessage,
  MyMessageStack,
} from './styles'
import { GptMessage } from '@services/nomos_api/entities/gptMessage'
import { Stack, Typography } from '@mui/material'
import { useChatSuport } from '@contexts/ChatSuport'
import { Button } from '@components/atoms'
import colors from '@theme/colors'

export function Messages() {
  const { isMyMessage, message } = useMessageContext()
  const { getHistory } = useChatSuport()
  const sessionMessages = getHistory() as GptMessage[]

  const msgIndex = sessionMessages.find((m) => m.id === message.id)

  const clearLocalStorageFilters = () => {
    const search = localStorage.getItem('@NOMOS:defaultFilters')
    if (search) localStorage.removeItem('@NOMOS:defaultFilters')
  }

  message.text = message.text?.replace(/^"?|"?$/g, '')
  message.html = message.html?.replace(/>“/g, '>')
  message.html = message.html?.replace(/”</g, '<')
  message.text = message.text?.replace(/\\n/g, '\n')
  message.html = message.html?.replace(/\\n/g, '\n')
  message.text = message.text?.replace(/<!--.*-->/g, '')
  message.html = message.html?.replace(/<!--.*-->/g, '')

  return (
    <>
      {isMyMessage() && (
        <MyMessageStack data-message-id={message.id}>
          <Stack direction="column" alignItems="flex-end">
            <MyMessage variant="$font-body-base" color="$color-text-primary">
              <MessageText />
            </MyMessage>
          </Stack>
        </MyMessageStack>
      )}
      {!isMyMessage() && (
        <BotMessageStack data-message-id={message.id}>
          <Stack direction="row">
            <BotMessage variant="$font-body-base" color="$color-text-primary">
              <MessageText />
              {msgIndex?.url && msgIndex?.total && msgIndex?.total > 3 && (
                <Button
                  text={
                    <Typography
                      variant="$font-body-2"
                      color="$color-text-primary"
                    >
                      ver mais {msgIndex.total}
                    </Typography>
                  }
                  icon="arrow"
                  iconcolor={colors['$color-action-text-secondary']}
                  sx={{
                    height: '34px',
                    m: 0,
                    marginTop: '8px',
                    backgroundColor: colors['$color-semantic-messagelight'],
                    ':hover': {
                      backgroundColor: colors['$color-semantic-messagelight'],
                    },
                  }}
                  href={msgIndex.url}
                  forcelocalnavigation="true"
                  navstate={
                    msgIndex?.filters
                      ? {
                          state: {
                            filters: msgIndex.filters,
                          },
                        }
                      : undefined
                  }
                  onClick={() => {
                    clearLocalStorageFilters()
                  }}
                />
              )}
            </BotMessage>
          </Stack>
        </BotMessageStack>
      )}
    </>
  )
}
